<template>
  <div class="container">
    <van-nav-bar
      class="header"
      :fixed="true"
      :title="lang.selectWords"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="middle">
      <h3>{{ lang.usualWords }}</h3>
      <span
        v-if="$route.query.id==='title'"
        class="font"
      >{{ lang.maxSentence }}</span>
      <span
        v-else
        class="font"
      >{{ lang.maxInSentence }}</span>
      <div class="word-title">
        {{ lang.facilities }}
      </div>
      <div class="content">
        <ul v-if="words">
          <li
            v-for="(item, index) in words"
            :key="index"
            :class="{ selected: chooseAfterValue.indexOf(item) != -1 }"
            @click="change(index, item)"
          >
            {{ item.chinese }}
          </li>
        </ul>
      </div>
      <div class="word-title">
        {{ lang.services }}
      </div>
      <div class="content">
        <ul v-if="words">
          <li
            v-for="(item, index) in words2"
            :key="index"
            :class="{ selected: chooseAfterValue.indexOf(item) != -1 }"
            @click="change(index, item)"
          >
            {{ item.chinese }}
          </li>
        </ul>
      </div>
    </div>

    <div class="footer">
      <van-button
        type="default"
        class="button"
        @click="cancel"
      >
        {{ lang.clearAll }}
      </van-button>
      <van-button
        type="danger"
        class="button"
        @click="submitwords"
      >
        {{ lang.confirm }}
      </van-button>
    </div>
  </div>
</template>

<script>
import lang from './../../../common/language/post';
import { Dialog } from 'vant';
export default {
  name: 'ServicesView',
  components: {},
  data() {
    return {
      propertyCategory: '',
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
      lang,
      words: [],
      words2: [],
      chooseAfterValue: [],
      historyValue:[],
      history:[],
      cnWords: [],
      enWords: [],
    };
  },
  mounted: function () {
    this.propertyCategory = this.$route.query.propertyCategory;
      this.axios
      .get(this.pub.getApi().GetServicesCommonWord)
      .then((res) => {
        let arr = [];
        let arr2 = [];
        let array = [];
        let array2 = [];
        const { data, status } = res;
        if (status == 200) {
          arr = data.result.facilitiesWords;
          // 过滤设施'
          arr.forEach((item, index) => {
            array.push(item);
          });
          arr2 = data.result.servicesWords;
          // 过滤服务'
          arr2.forEach((item, index) => {
            array2.push(item);
          });
        }
        // 设施和服务关键字数组中对象去重
        var hash = {};
        var finalarr = [];
        finalarr = array.reduce(function (item, next) {
          hash[next.chinese] ? '' : (hash[next.chinese] = true && item.push(next));
          return item;
        }, []);
        this.words = finalarr;
        // 设施和服务关键字数组中对象去重
        var hash2 = {};
        var finalarr2 = [];
        finalarr2 = array2.reduce(function (item, next) {
          hash2[next.chinese] ? '' : (hash2[next.chinese] = true && item.push(next));
          return item;
        }, []);
        this.words2 = finalarr2;

        // function unique(arr) {
        //   if (!Array.isArray(arr)) {
        //     console.log('type error!');
        //     return;
        //   }
        //   var array = [];
        //   for (var i = 0; i < arr.length; i++) {
        //     if (!array.includes(arr[i])) {
        //       array.push(arr[i]);
        //     }
        //   }
        //   return array;
        // }
        // this.words = unique(array);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    //提交选项中的文字,应该判断是从哪里点进来的哪一个button
    submitwords() {
      let newCnArray = [];
      let newEnArray = [];
      let ChiWords=''
      let EngWords=''
      newCnArray = this.chooseAfterValue.map((item) => {
        ChiWords =item.chinese+" "
        return  ChiWords;
        // return item.chinese
      });
      newEnArray = this.chooseAfterValue.map((item) => {
        EngWords=item.english+" "
        return EngWords
        // return item.english
      });
      this.cnWords = newCnArray;
      this.enWords = newEnArray;
      if (this.$route.query.id === 'services') {
        this.store.commit('setServicesList', this.cnWords);
        this.store.commit('setenServicesList', this.enWords);
      }
      window.stop();
      this.$router.go(-1);
      // this.$router.push('/post');
    },

    //清空选中
    cancel() {
      this.chooseAfterValue = [];
    },
    change(n, value) {
      if (this.chooseAfterValue.indexOf(value) != -1) {
        this.chooseAfterValue.splice(this.chooseAfterValue.indexOf(value), 1);
      } else {
        if (this.$route.query.id === 'services'&& this.chooseAfterValue.length >= 10) {
          return false;
        } 
          this.chooseAfterValue.push(value);
        
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 47px;
  background-color: #fafbfc;
  position: absolute;
  top: 0;
  left: 0;
}
.middle {
  position: absolute;
  top: 50px;
  bottom: 50px;
  left: 0;
  overflow: auto;
  padding: 19px 17px 3px 16px;
  text-align: left;
}
h3 {
  margin: 2px 0 4px 0;
  font-size: 17px;
  color: #333333;
}
.font {
  font-size: 12px;
  color: #999999;
}
ul {
  width: 100%;
  /* height: 460px; */
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
ul li {
  width: 30%;
  /* height: 32px; */
  opacity: 1;
  font-weight: 400;
  font-family: PingFangSC, PingFangSC-Regular;
  color: #333333;
  text-align: center;
  line-height: 16px;
  margin-bottom: 10px;
  font-size: 12px;
  display: flex;
  border: 1px solid #e5e8e9;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
}
ul:after {
  content: '';
  width: 30%;
}
.selected {
  color: #ffffff;
  background-color: #ff0000;
}
.footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.footer button {
  width: 50%;
  height: 50px;
  margin: 0;
  padding: 0;
}
.word-title {
  margin-top: 15px;
  font-weight: bold;
  font-size: 20px;
}
</style>
